import React, { useEffect, useState } from "react";

const Turnstile = ({ siteKey, onVerify }) => {
  const [token, setToken] = useState(null);
  const [turnstileActive, setTurnstileActive] = useState(false);

  useEffect(() => {
    if (!turnstileActive) {
      setTurnstileActive(true);
      const turnstileScript = document.createElement("script");
      turnstileScript.src =
        "https://challenges.cloudflare.com/turnstile/v0/api.js";
      turnstileScript.async = true;
      document.head.appendChild(turnstileScript);

      turnstileScript.onload = () => {
        window.turnstile.render("#turnstile-container", {
          sitekey: siteKey,
          theme: "light",
          callback: (token) => {
            setToken(token);
            onVerify(token);
          },
        });
      };

      return () => {
        document.head.removeChild(turnstileScript);
      };
    }
  }, [siteKey, onVerify]);

  return (
    <div
      id="turnstile-container"
      className={`cf-turnstile turnstile-widget ${token ? "fade-out" : ""}`}
    ></div>
  );
};

export default Turnstile;
